import { Box } from "@mui/material";

import NotificationCardWrapper from "../NotificationCardWrapper";
import profile1 from "../../../../media/svg/Avatar/Avatar.svg";
import DiscussionThumbnail from "../../../../media/svg/DiscussionThumbnail.png";

const NotificationInvitationSummary = () => {
  return (
    <NotificationCardWrapper
      firstChild={
        <img
          width='48px'
          height='48px'
          style={{ borderRadius: "50%", border: "solid 2px black" }}
          src={profile1}
          alt='profilePicture'
        />
      }
      seccondChild={
        <Box style={{ fontWeight: "600" }}>
          Anna invited you to Who will win the market?
        </Box>
      }
      ThirdChild={
        <img
          width='48px'
          height='48px'
          style={{ borderRadius: "8px", border: "solid 2px black" }}
          src={DiscussionThumbnail}
          alt='profilePicture'
        />
      }
    />
  );
};

export default NotificationInvitationSummary;
